/**
 * @module experience/credit-check
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const FORM_NAME_CONSTANTS = {
  COMMUNICATIONFORM: 'communicationForm',
  BILLING_TYPE: 'BILLING',
  SHIPPING_TYPE: 'SHIPPING',
  ALLOWED: 'allowed',
};

export const FORM_NAME_CONST = {
  NAMEADDRESSFORM: 'nameAddressForm',
  COMMUNICATIONFORM: 'communicationForm',
  IDENTIFICATIONFORM: 'identificationForm',
};

export const IDENTIFICATION_FORM = {
  IDENTIFICATIONFORM: 'identificationForm',
  SSN: 'ssn',
  RETYPE_SSN: 'reTypeSSN',
  ELIGIBLE_AGE: 18,
  DRIVERS_LICENSE: 'DRIVERSLICENSE',
};

export const CREDIT_CLASS = {
  SUCCESS: 'A',
};

export const TERMS_AND_CONDITION_CONSTANTS = {
  CONTENT_TYPE_HTML: 'HTML',
  LANGUAGE_CODE: 'en',
  POSTPAID: 'POSTPAID',
  LEGAL_TEXT: 'LEGAL_TEXT',
  LEGAL_HTML: 'LEGAL_HTML',
  CREDIT_CONSENT: 'CREDIT_CONSENT',
  TERMS_AND_CONDITION_CONTAINER_ID: '#tncContainer',
  ACTIVATION: 'ACTIVATION',
  SHARED_EXPERIENCE_MODULE: 'SharedExperienceModule',
  TERMS_AND_CONDITION_SERVICE: 'TermsAndConditionService',
};

export const SERVICE_DEPOSIT_CONST = {
  PER_LINE: 'Per line',
  VOICE: 'Voice',
  MOBILE_INTERNET: 'Mobile internet',
  GSM: 'GSM',
  MBB: 'MBB',
};

export const BUTTON_CONST = {
  ID: 'continueButton',
  NAME: 'submit',
  CLASS: 'btn btn-primary',
  TYPE: 'Primary',
};

export const CREDIT_CHECK_FORM = {
  CREDIT_COMMUNICATION: '/credit-check/communications',
  CREDIT_RESULT: '/credit-check/result',
};

export const CREDIT_CHECK_MODULE_COMPONENTS = {
  CREDIT_CHECK_MODULE_NAME: 'Credit Check Module',
  CREDIT_CHECK_SERVICE: 'CreditCheckService',
  COMMUNICATION_COMPONENT: 'CommunicationComponent',
  CREDIT_CHECK_COMMUNICATION_COMPONENT: 'CreditCheckCommunicationsComponent',
  CREDIT_CHECK_ERROR_COMPONENT: 'CreditCheckErrorComponent',
  CREDIT_CHECK_FORM_COMPONENT: 'CreditCheckFormComponent',
  CREDIT_CHECK_RESULT_COMPONENT: 'CreditCheckResultComponent',
  IDENTIFICATION_COMPONENT: 'IdentificationComponent',
  NAME_AND_ADDRESS_COMPONENT: 'NameAndAddressComponent',
};
